// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const EditIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M5.49 4c.85-.04 1.75 0 2.61-.02.53 0 1.17-.01 1.69.04q.29.06.52.25c.83.66.53 2.1-.56 2.3-.4.07-.79.05-1.2.04h-2c-.96 0-2.26-.15-2.38 1.24-.06.6-.01 1.3-.01 1.9v8.83c.04.55.54 1.14 1.1 1.17q1.05.05 2.1.03h7.19c.6 0 1.28.02 1.86-.04.4-.03.87-.5.96-.89s.07-.78.07-1.18v-2.11q-.02-.62.02-1.2c.15-1.13 1.36-1.49 2.21-.8.3.3.41.68.42 1.1v1.82c-.02 1.02.07 2.06-.17 3.06-.43 1.6-1.97 2.83-3.65 2.85l-2.6.02H6.62c-.58 0-1.4.02-1.95-.08-.66-.13-1.38-.53-1.86-.97-.8-.74-1.27-1.79-1.29-2.88V9.2c0-.67-.05-1.39.09-2.04C2 5.21 3.54 4.06 5.49 4"
        opacity=".5"
      />
      <path d="M15.34 4.63c.09.06.78.76.89.87l2.08 2.07c.26.26.86.88 1.12 1.08-.44.46-.95.95-1.4 1.4l-2.77 2.75-1.78 1.78c-.39.39-.92 1-1.43 1.2-.59.24-1.23.43-1.83.63-.69.24-1.64.6-2.35.73-.28.02-.48-.06-.7-.23-.72-.6-.1-1.66.16-2.44l.5-1.49c.11-.31.38-1.16.57-1.4.44-.55 1.17-1.22 1.68-1.73l3.5-3.46c.57-.56 1.22-1.18 1.76-1.76m3.95-3.03h.12c.79-.03 1.3.3 1.85.82.64.62 1.22 1.2 1.24 2.15.02 1.23-.86 1.88-1.65 2.69q-.23-.2-.44-.42l-2.3-2.28c-.44-.44-.93-.9-1.35-1.35.9-.76 1.24-1.54 2.53-1.61" />
    </g>
  </SvgIcon>
);

export default EditIcon;
